"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedsunny = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedsunny` : '') + (description ? ` desc-brandedsunny` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedsunny"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedsunny"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "m55.2 29.38-9 5.1a1.6 1.6 0 0 0-.75 1.8l2.76 9.96a1.6 1.6 0 0 1-1.97 1.96l-9.95-2.75a1.6 1.6 0 0 0-1.81.76l-5.1 8.98a1.6 1.6 0 0 1-2.77 0l-5.09-8.98a1.6 1.6 0 0 0-1.8-.76L9.75 48.2a1.6 1.6 0 0 1-1.97-1.96l2.76-9.96a1.6 1.6 0 0 0-.76-1.8L.8 29.38a1.6 1.6 0 0 1 0-2.77l8.98-5.09c.63-.36.94-1.1.76-1.8L7.79 9.75a1.6 1.6 0 0 1 1.97-1.97l9.95 2.76a1.6 1.6 0 0 0 1.81-.76L26.62.8a1.6 1.6 0 0 1 2.77 0l5.09 8.98c.36.64 1.1.95 1.8.76l9.96-2.76a1.6 1.6 0 0 1 1.97 1.97l-2.76 9.95c-.2.7.12 1.45.76 1.81l8.98 5.09a1.6 1.6 0 0 1 0 2.77Z",
    fill: "#F7B941"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M27.98 46.47a18.5 18.5 0 1 0 0-36.99 18.5 18.5 0 0 0 0 37Z",
    fill: "#FFEBC7"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M28 46.53a18.52 18.52 0 0 0 13.6-31.08c-7.88 9.6-17 18.09-27.1 25.25a18.48 18.48 0 0 0 13.48 5.83Z",
    fill: "#FFDC9C"
  }));
};
var _default = exports.default = brandedsunny;